export default __webpack_public_path__ + "static/kako-namestiti-lightroom-presets-IOS-0c9b160489c68ceb350198b0a7a62833.pdf";